import { ServiceProvider, ViewModelProvider } from '@/providers';
import { createContext } from 'react';

export type ServicesContextValues = ServiceProvider & { viewModels: ViewModelProvider };

// Passing casting to any to prevent setting a default value. The runtime should define these (app, storybook, etc.)
// eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/no-unsafe-argument
export const ServicesContext = createContext<ServicesContextValues>({} as any);
